import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex-center items-start" }
const _hoisted_2 = ["aria-label"]

import { computed } from 'vue';
import AnimateValue from '@/core/ui-components/AnimateValue.vue';
import siteContextService from '@/b2c/shared/site-context.service';
import useTEMPB2CFeatureBasket from '@/b2c/basket/useTEMPB2CFeatureBasket';
import BasketLink from '@/shared/navigation/BasketLink.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniBasket',
  setup(__props) {

const { basketQuantity } = useTEMPB2CFeatureBasket();

const showBasket = computed(() => {
    return !siteContextService.basketIsDisabled;
});

const getAccessibleLabel = computed(() => {
    switch (basketQuantity.value) {
    case 0:
        return 'Global/A11y/OpenBasket';
    case 1:
        return 'Global/A11y/BasketWithSingleQuantity';
    default:
        return 'Global/A11y/BasketWithPluralQuantity';
    }
});

return (_ctx: any,_cache: any) => {
  const _component_c_icon = _resolveComponent("c-icon")!

  return (_unref(showBasket))
    ? (_openBlock(), _createBlock(BasketLink, {
        key: 0,
        "aria-labelledby": "accessibleBasketLabel",
        role: "menuitem"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_c_icon, {
              name: "icon-basket",
              class: "h-18 -mt-3",
              "aria-hidden": "true"
            }),
            (_unref(basketQuantity))
              ? (_openBlock(), _createBlock(AnimateValue, {
                  key: 0,
                  value: _unref(basketQuantity),
                  class: "inline-block text-right min-w-15 text-11 xl:text-12"
                }, null, 8, ["value"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("span", {
            id: "accessibleBasketLabel",
            class: "sr-only",
            "aria-label": _ctx.$dictionary.get(_unref(getAccessibleLabel), [_unref(basketQuantity).toString()])
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})